export default {
  REDIRECT_ENDPOINT: process.env.REACT_APP_REDIRECT_END_POINT || 'http://localhost:3000',
  CALLBACK_END_POINT: process.env.REACT_APP_CALLBACK_END_POINT,
  LANDING_PAGE_END_POINT: process.env.REACT_APP_LANDING_PAGE_END_POINT,
  BACKEND_END_POINT: process.env.REACT_APP_BACKEND_END_POINT,
}
